import e from "./ghl-ui.es1474.js";
import t from "./ghl-ui.es1434.js";
function u(r) {
  return t(1, arguments), e(r).getFullYear();
}
export {
  u as default
};
